export function numberComparator(valueA: number | string, valueB: number | string) {
    return (
        typeof valueA === 'string'
            ? Number.parseFloat(valueA.replace(/,/g, ""))
            : typeof valueA === "number"
                ? valueA
                : -Infinity
    ) - (
        typeof valueB === 'string'
            ? Number.parseFloat(valueB.replace(/,/g, ""))
            : typeof valueB === "number"
                ? valueB
                : -Infinity
    );
}
